import styled from "styled-components";
import { blue, mazarine } from "../../styles/variables.style";

export const HeaderTarifsWrapper = styled.div`
  .bande_bleu {
    padding-top: 74px;
    text-align: center;
    background: ${mazarine};

    .faites {
      margin-top: 80px;
      font-size: 40px;
      font-weight: bold;
      color: white;
    }
    .suivre {
      color: white;
      padding-bottom: 80px;
      font-size: 30px;
      font-weight: bold;
      a {
        color: ${blue};
        &:hover {
          color: white;
        }
      }
    }
  }
  .titre1 {
    margin-top: 100px;
    font-size: 20px;
    color: #788896;
    text-align: center;
  }
  .titre2 {
    font-size: 45px;
    text-align: center;
  }

  i b {
    color: ${blue};
    cursor: pointer;
  }
`;
